import { useEffect, useState } from 'react';
import { apiError, getResearch } from '../../lib/research';

export const useCoinEvidence = (coinId, enabled) => {
  const [state, setState] = useState({ data: null, error: '', loading: false });
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    if (!enabled || !coinId) { setState({ data: null, error: '', loading: false }); return () => controller.abort(); }
    setState({ data: null, error: '', loading: true });
    getResearch('/crypto/signal-evidence', { params: { coin_id: coinId }, signal: controller.signal, timeout: 45000 })
      .then(({ data }) => {
        if (controller.signal.aborted) return;
        if (data.coin_id !== coinId || data.evidence_kind !== 'daily_price_samples') throw new Error('Signal evidence identity did not match the selected coin.');
        setState({ data, error: '', loading: false });
      }).catch(error => { if (!controller.signal.aborted) setState({ data: null, error: apiError(error), loading: false }); });
    return () => controller.abort();
  }, [coinId, enabled, revision]);
  return { ...state, data: state.data?.coin_id === coinId ? state.data : null, refresh: () => setRevision(value => value + 1) };
};